import { createRouter, createWebHistory } from "vue-router";
import AccueilView from "../views/AccueilView";
import VisiterView from "../views/VisiterView";
import AlentoursView from "../views/AlentoursView";
import DescriptionView from "../views/DescriptionView";
import GalleryView from "../views/GalleryView";
import TarifsView from "../views/TarifsView";
import LivreView from "../views/LivreView";
import DisponibiliteView from "../views/DisponibiliteView";

import RezDeChausseeView from "@/views/gallery/RezDeChausseeView.vue";
import CuisineView from "@/views/gallery/CuisineView.vue";
import SalonView from "@/views/gallery/SalonView.vue";
import SalleAMangerView from "@/views/gallery/SalleAMangerView.vue";
import SalleDeBainView from "@/views/gallery/SalleDeBainView.vue";
import JardinView from "@/views/gallery/JardinView.vue";
import ChambreEtageView from "@/views/gallery/ChambreEtageView.vue";
import ChambrePaliereView from "@/views/gallery/ChambrePaliereView.vue";
import GalleryAllPhotoView from "@/views/GalleryAllPhotoView.vue";
import RezDeChaussePlanView from "@/views/gallery/RezDeChaussePlanView.vue";
import EtagePlanView from "@/views/gallery/EtagePlanView.vue";

const routes = [
      {
            path: "/",
            name: "accueil",
            component: AccueilView,
      },

      {
            path: "/descriptifs",
            name: "descriptifs",
            component: DescriptionView,
      },

      {
            path: "/descriptifs/gallerie-toutes-les-photos",
            name: "galleryAllPhoto",
            component: GalleryAllPhotoView,
      },

      {
            path: "/descriptifs/gallerie",
            name: "gallerie",
            component: GalleryView,
            children: [
                  {
                        path: "",
                        redirect: { name: "rdc" },
                  },

                  {
                        path: "rez-de-chaussee",
                        name: "rez-de-chaussee-plan",
                        component: RezDeChaussePlanView,
                        children: [
                              {
                                    path: "",
                                    redirect: {
                                          name: "chambre-rez-de-chaussee",
                                    },
                              },

                              {
                                    path: "chambre",
                                    name: "chambre-rez-de-chaussee",
                                    component: RezDeChausseeView,
                              },

                              {
                                    path: "salle-de-bain",
                                    name: "salle-de-bain-rez-de-chausse",
                                    component: SalleDeBainView,
                              },

                              {
                                    path: "cuisine",
                                    name: "cuisine-rez-de-chausse",
                                    component: CuisineView,
                              },

                              {
                                    path: "salon",
                                    name: "salon-rez-de-chausse",
                                    component: SalonView,
                              },

                              {
                                    path: "salle-a-manger",
                                    name: "salle-a-manger-rez-de-chausse",
                                    component: SalleAMangerView,
                              },
                        ],
                  },

                  {
                        path: "etage",
                        name: "etage",
                        component: EtagePlanView,
                        children: [
                              {
                                    path: "",
                                    redirect: {
                                          name: "chambre-etage",
                                    },
                              },
                              {
                                    path: "chambre-paliere",
                                    name: "chambre-paliere",
                                    component: ChambrePaliereView,
                              },

                              {
                                    path: "chambre-etage",
                                    name: "chambre-etage",
                                    component: ChambreEtageView,
                              },
                        ],
                  },

                  {
                        path: "jardin",
                        name: "jardin",
                        component: JardinView,
                  },
            ],
      },

      {
            path: "/comment-arriver",
            name: "arriver",
            component: VisiterView,
      },

      {
            path: "/alentours",
            name: "alentours",
            component: AlentoursView,
      },

      {
            path: "/livredor",
            name: "livre",
            component: LivreView,
      },

      {
            path: "/disponibilite",
            name: "disponibilite",
            component: DisponibiliteView,
      },

      {
            path: "/tarifs",
            name: "tarifs",
            component: TarifsView,
      },
];

const router = createRouter({
      history: createWebHistory(),
      routes,
      scrollBehavior(to) {
            if (to.hash) {
                  return new Promise((resolve) => {
                        setTimeout(() => {
                              const el = document.querySelector(to.hash);

                              if (el) {
                                    const top =
                                          el.getBoundingClientRect().top +
                                          window.scrollY -
                                          100;

                                    resolve({ top, behavior: "smooth" });
                              } else {
                                    resolve({ top: 0 });
                              }
                        }, 300);
                  });
            }

            return { top: 0 };
      },
});

/*router.beforeEach((to, from, next) => {
  if (!to.hash && to.path !== from.path) {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
  next()
})*/

export default router;
